import React, { useState, useEffect } from 'react';
import axiosBaseURL from './httpCommon';
import GenerateKey from './GenerateKey';
import ApiUsageDetails from './ApiUsageDetails';

import BoltHeader from './BoltHeader';
import Footer from './Footer';

import './ApiUsage.css';

const ApiUsage = () => {
    const [apiKey, setApiKey] = useState('');
    const [apiShortKey, setApiShortKey] = useState('Generate API key');
    const [apiUsageDetails, setApiUsageDetails] = useState(null);

    
    // useEffect(() => {
    //     const fetchApiShortKey = async () => {
    //         try {
    //             const response = await axiosBaseURL.post('/apikey/generate');
    //             if (response.data.status && response.data.data.api_short_key) {
    //                 setApiShortKey(response.data.data.api_short_key);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching API short key:', error);
    //         }
    //     };

    //     fetchApiShortKey();
    // }, []);

    useEffect(() => {
        const fetchApiUsageDetails = async () => {
            try {
                const response = await axiosBaseURL.post('/apikey/info');
                if (response.data.status && response.data.data) {
                    console.log("api details:",response.data);
                  setApiUsageDetails(response.data.data);
		  if (response.data.data.api_short_key){
		    setApiShortKey("...."+response.data.data.api_short_key);
		  } else {
		    setApiShortKey("Generate API key");
		  }
                }
            } catch (error) {
                console.error('Error fetching API usage details:', error);
            }
        };

        fetchApiUsageDetails();
    }, []);


    return (
        
        <div api-usage-content-container>
            <BoltHeader />
            <h1>API Usage</h1>
            <GenerateKey api_key={apiKey} apiShortKey={apiShortKey}/>
            <ApiUsageDetails apiUsageDetails={apiUsageDetails}/>
            <Footer />
        </div>
    );
};

export default ApiUsage;
